export default __webpack_public_path__ + "static/Lazada2-64f07c1e44cbe728f22699bc983e0001.jpg";